<!-- Hero Section -->
<section class="csr-hero-section">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left Text Content -->
      <div class="col-lg-5 col-md-12 csr-text-content">
        <h1 class="hero-title">Kalpita's Commitment to Corporate Social Responsibility</h1>

        <h2 class="sub-heading">Mission Statement</h2>
        <p class="mission-text">
          Together with our people, partners, and communities, we strive to build healthier, empowered, and sustainable
          societies.
        </p>

        <h2 class="sub-heading">Impact at a Glance</h2>
        <ul class="impact-list">
          <li>100+ lives benefitted from our blood donation camps.</li>
          <li>300+ school children supported through mid-day meals</li>
          <li>10+ families assisted with rations and clothes.</li>
        </ul>

        <button class="btn explore-btn" (click)="scrollToInitiatives()">
          Explore Our Initiatives
        </button>

      </div>

      <!-- Right Image Content -->
      <div class="col-lg-7 col-md-12 csr-image-content">
        <video #heroVideo preload="auto" src="../../../../assets/about-company/social-responsibility/csr-herovideo.webm"
          class="csr-graphic" autoplay loop muted playsinline disablePictureInPicture>
        </video>
      </div>
    </div>
  </div>
</section>
<!-- Our CSR Philosophy and Mission Section -->
<section class="solutions-section" #philosophySection [class.start-animation]="isPhilosophyVisible">
  <div class="container">
    <div class="section-header text-center mx-auto">
      <h2>Our CSR Philosophy & Mission</h2>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="solutions-image-container">
          <div class="solution-image-card image-one">
            <img src="../../../assets/home/about-us/about-us-img1.png" alt="Team collaborating on computer">
          </div>
          <div class="solution-image-card image-two">
            <img src="../../../assets/home/about-us/about-us-img2.png" alt="Two colleagues looking at a laptop">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="solutions-content">
          <!-- <h3>Our Purpose</h3> -->
          <p>
            At Kalpita Technologies, CSR is not just an initiative, it is a responsibility and a culture of giving back.
            What we receive from society, we return in impactful ways that create a ripple effect of positive change.
            From tackling hunger and malnutrition to fostering education, healthcare, sustainability, equality, and
            rural growth, our efforts are designed to uplift communities and inspire lasting transformation. We also
            recognize that every individual has been touched by these challenges in some way, which is why we encourage
            both our company and our people to give back in ways that resonate with their personal experiences. Guided
            by this philosophy, our mission is to create healthier, more inclusive, and sustainable societies, where
            technology, people, and purpose come together to drive positive change.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- UN SDG Alignment Section -->
<section class="un-sdg-section" #sdgSection [class.start-animation]="isSdgVisible">
  <div class="container">
    <h2 class="sdg-section-title">UN SDG Alignment</h2>

    <div class="sdg-intro-text">
      <p>
        While the United Nations has outlined 17 Sustainable Development Goals (SDGs) to address global challenges,
        most organizations focus on a select few where they can create the strongest and most meaningful impact.
        At Kalpita Technologies, we have carefully chosen the SDGs that align with both our values and
        our ability to contribute, including:
      </p>
    </div>

    <div class="sdg-goals-grid">
      <div class="sdg-goal-item" *ngFor="let goal of sdgGoals">
        <div class="sdg-circles-container">
          <!-- Orange Circle (Back) -->
          <img [src]="goal.orangeCircleImage" alt="Orange Circle" class="orange-circle">

          <!-- Blue Icon Circle (Front) -->
          <img [src]="goal.blueIconImage" [alt]="goal.title" class="blue-icon-circle">
        </div>

        <div class="sdg-goal-info">
          <p class="sdg-number">{{ goal.number }}</p>
          <p class="sdg-title">{{ goal.title }}</p>
          <p class="sdg-subtitle" *ngIf="goal.subtitle">{{ goal.subtitle }}</p>
        </div>
      </div>
    </div>

    <div class="sdg-closing-text">
      <p>
        By concentrating on these areas, we ensure our efforts are impactful, measurable, and sustainable,
        while still contributing to the larger global vision of a better future for all.
      </p>
    </div>
  </div>
</section>
<!-- CSR Initiatives Section -->
<section class="csr-initiatives-section" #initiativesSection id="initiatives">
  <div class="container">
    <h2 class="section-title">Our CSR Initiatives</h2>

    <div class="initiatives-wrapper">
      <!-- ADDED: #initiativeCard reference variable here -->
      <div class="initiative-card" *ngFor="let initiative of csrInitiatives; let i = index" #initiativeCard>

        <!-- Image Content (Will animate from Left) -->
        <div class="initiative-image-wrapper">
          <div class="circular-image-container" [ngClass]="initiative.gradientClass">
            <div class="white-border">
              <img [src]="initiative.imagePath" [alt]="initiative.title" class="initiative-image">
            </div>
          </div>
        </div>

        <!-- Text Content (Will animate from Right) -->
        <div class="initiative-text-content" [ngClass]="initiative.background">
          <h3 class="initiative-title">{{ initiative.title }}</h3>
          <!-- <p class="initiative-description">{{ initiative.description }}</p> -->
          <p class="initiative-description">

            <!-- CASE 1: If structured parts exist -->
            <ng-container *ngIf="initiative.descriptionParts; else plainText">

              <ng-container *ngFor="let part of initiative.descriptionParts">

                <span *ngIf="part.text">
                  {{ part.text }}
                </span>

                <a *ngIf="part.linkText" [href]="part.url" target="_blank" rel="noopener" class="csr-link">
                  {{ part.linkText }}
                </a>

              </ng-container>

            </ng-container>

            <!-- CASE 2: Plain text fallback -->
            <ng-template #plainText>
              {{ initiative.description }}
            </ng-template>

          </p>
          <div class="heroes-list" *ngIf="initiative.heroes.length > 0">
            <p class="heroes-intro">Few of the unsung heroes are : </p>
            <ul class="heroes-items">
              <li *ngFor="let hero of initiative.heroes">{{ hero }}</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<!-- Impact Metrics Section -->
<section class="impact-metrics-section" #impactSection [class.start-animation]="isImpactVisible">
  <div class="container">
    <h2 class="impact-section-title">Impact Metrics</h2>

    <p class="impact-intro-text">
      We measure success through a mix of tangible outcomes and intangible ripple effects.
    </p>

    <div class="impact-metrics-wrapper">
      <div class="impact-metric-card" *ngFor="let metric of impactMetrics">

        <!-- 3D TARGET: Put #impactCard HERE -->
        <div class="impact-image-card" #impactCard>
          <img [src]="metric.imagePath" [alt]="metric.title" class="impact-image">
        </div>

        <!-- Text Content (Static) -->
        <div class="impact-content" [ngClass]="'text-' + metric.textColor">
          <h3 class="impact-title">{{ metric.title }}</h3>
          <ul class="impact-list">
            <li *ngFor="let item of metric.metrics">{{ item }}</li>
          </ul>
        </div>

      </div>
    </div>

    <p class="conclusion-text">
      This multi-dimensional approach ensures that our CSR is not just
      about numbers but about lasting, meaningful change.
    </p>
  </div>
</section>